const PrimaryButton = ({ children, ...props }) => {
    return (
      <button
        className="w-full bg-green-900 hover:bg-green-800 text-white py-3 rounded-lg font-semibold transition"
        {...props}
      >
        {children}
      </button>
    );
  };
  
  export default PrimaryButton;
  